import { atsApiQuery } from '..';
import { FILTER_OPTIONS_STALE_SECONDS } from '@/constants/app-constants';

export const atsApplicationApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllJobs: builder.query({
        transformResponse: (response) => response?.data?.ats_jobs,
        query: ({ params }) => {
          return {
            url: `ats_jobs`,
            method: 'get',
            params,
          };
        },
      }),
      getAllJobsList: builder.query({
        // Filter-option data, same as departments/offices: the 60s default
        // evicted it between page visits and forced a refetch every time.
        keepUnusedDataFor: FILTER_OPTIONS_STALE_SECONDS,
        transformResponse: (response) => response?.data?.ats_jobs,
        query: ({ params }) => {
          return {
            url: `ats_jobs/list`,
            method: 'get',
            params,
          };
        },
      }),
      // Hiring-team endpoints moved to React Query — see
      // `src/api/useGetHiringTeamOfJob`.
    };
  },
  overrideExisting: true,
});

export const { useGetAllJobsQuery, useGetAllJobsListQuery } = atsApplicationApi;
